export default {
  name: 'CategoryCodec',

  methods: {
    encodeCategories(categories) {
      const MAX_CATEGORY_ID = 200;
      const sorted = Array.from(new Set(categories)).sort((a, b) => a - b);
      const bits = new Uint8Array(Math.ceil(MAX_CATEGORY_ID / 8));

      for (const id of sorted) {
        if (id >= 0 && id < MAX_CATEGORY_ID) {
          const byteIndex = Math.floor(id / 8);
          const bitIndex = id % 8;
          bits[byteIndex] |= 1 << bitIndex;
        }
      }

      let lastNonZeroIndex = bits.length - 1;
      while (lastNonZeroIndex > 0 && bits[lastNonZeroIndex] === 0) {
        lastNonZeroIndex--;
      }

      const trimmed = bits.slice(0, lastNonZeroIndex + 1);
      const base64 = btoa(String.fromCharCode(...trimmed));

      // URL-safe Base64
      return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    },

    decodeCategories(encoded) {
      // Restore padding
      let base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
      while (base64.length % 4 !== 0) {
        base64 += '=';
      }

      const binary = atob(base64);
      const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
      const categories = [];

      for (let i = 0; i < bytes.length; i++) {
        for (let bit = 0; bit < 8; bit++) {
          if (bytes[i] & (1 << bit)) {
            categories.push(i * 8 + bit);
          }
        }
      }

      return categories;
    }
  }
}
